









































































































































































































































import Vue from "vue";
import Navbar from "../components/Navbar.vue";
import MajdaFooter from "../components/MajdaFooter.vue";

import * as parallaxHelper from "../helpers/parallax.helper";

export default Vue.extend({
  name: "Wiki",
  components: {
    Navbar,
    MajdaFooter,
  },
  mounted: function () {
    parallaxHelper.hook();
  },
});
